// @flow
import React from 'react'

const WiFi = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="17" viewBox="0 0 21 17">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C" strokeLinecap="square">
        <circle cx="10.5" cy="14.5" r="2" />
        <path d="M16.2 8.8c-1.5-1.4-3.5-2.3-5.7-2.3s-4.2.9-5.7 2.3M20.4 4.6c-2.5-2.5-6-4.1-9.9-4.1C6.6.5 3.1 2.1.6 4.6" />
      </g>
    </svg>
  )
}

export default WiFi



// WEBPACK FOOTER //
// ./src/components/Icons/WiFi.js